import { Reducer } from "redux";
import { AtlasActions, AtlasActionTypes } from "./AtlasActions";
import { IAtlasState } from "./AtlasModels";

const initialAtlasState: IAtlasState = {
  data: {},
};

export const atlasReducer: Reducer<IAtlasState, AtlasActions> = (
  state = initialAtlasState,
  action
) => {
  switch (action.type) {
    case AtlasActionTypes.RESPONSE_DATA:
      return { data: action.payload };
    default:
      return state;
  }
};
